import { useEffect, useRef, useState, memo } from "react";
import Heading from "../heading/heading";
import styles from "./attachment-home.module.css";
import { getMultiMediaList } from "../../services/news/news.service";
import { getAttachmentsList } from "../../services/about/about.service";
import {
  StackedCarousel,
  ResponsiveContainer,
} from "react-stacked-center-carousel";
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from "react-image-gallery";

export default function AttachmentHome() {
  let titleRef = useRef();
  let [title, setTitle] = useState("");
  let [activeIndex, setActiveIndex] = useState(0);
  let [multiMedia, setMultiMedia] = useState([]);
  let [data, setData] = useState([]);
  let [open, setIsOpen] = useState(false);
  let [images, setImages] = useState([]);
  let [loading, setLoading] = useState(false);
  const ref = useRef();
  useEffect(() => {
    getMultiMediaList().then(({ data }) => {
      setMultiMedia((data && data.data) || []);
    });
  }, []);
  useEffect(() => {
    const mapAttachment = [];
    const result = [];
    setLoading(true);
    let tmpFile = [...multiMedia];
    for (let tmp of tmpFile) {
      result.push({
        type: tmp.media_content_type,
        title: tmp.title,
        cover: tmp.attachment_files[0].server_relative_url,
      });
      setLoading(false);
    }
    setData(result);
  }, [multiMedia]);
  const handleGallery = (data, active) => {
    if (active === activeIndex) {
      setIsOpen(true);
      const tmp = [];
      tmp.push({
        original: data,
        thumbnail: data,
      });
      setImages(tmp);
    } else {
      setIsOpen(false);
    }
  };
  return (
    <>
      <div className="container">
        <Heading title={"چند رسانه ای"} icon={"fa fa-images"}></Heading>
      </div>
      <div className={styles.attachmentHomeWrapper}>
        <div className="container">
          <div className="row">
            <div className="col-xs-12 hidden-md hidden-lg">
              <div className={styles.carouselTitle} ref={titleRef}>
                <div className={styles.squareSide} />
                <div className={styles.courseTitleText}>
                  <i className="fa fa-images" />
                  {title}
                </div>
              </div>
            </div>
            <div className={"col-xs-12 col-md-8"}>
              {!loading ? (
                <div className={styles.carouselSide}>
                  {Array.isArray(data) && data.length >= 1 ? (
                    <div>
                      <ResponsiveContainer
                        carouselRef={ref}
                        render={(parentWidth, carouselRef) => {
                          let currentVisibleSlide = 2;
                          if (parentWidth <= 1440) currentVisibleSlide = 1;
                          if (parentWidth <= 1080) currentVisibleSlide = 1;
                          return (
                            <StackedCarousel
                              ref={carouselRef}
                              slideComponent={(props) => (
                                <Card props={{ ...props, handleGallery }} />
                              )}
                              slideWidth={parentWidth > 768 ? 600 : 300}
                              fadeDistance={0.9}
                              carouselWidth={parentWidth}
                              data={data}
                              onActiveSlideChange={(index) => {
                                setTitle(data[index].title);
                                setActiveIndex(index);
                              }}
                              maxVisibleSlide={1}
                              useGrabCursor
                            />
                          );
                        }}
                      />
                      <div className={styles.attachmentArrows}>
                        <div onClick={() => ref.current.goBack()}>
                          <i className="fa fa-arrow-left" />
                        </div>
                        <div className={styles.bullets}>
                          {data.map((item, index) => (
                            <div
                              className={
                                activeIndex === index
                                  ? styles.activeBullet
                                  : styles.simpleBullet
                              }
                              key={`bullet-carousel-${index}`}
                              onClick={() =>
                                ref.current.swipeTo(index - activeIndex)
                              }
                            />
                          ))}
                        </div>
                        <div onClick={() => ref.current.goNext()}>
                          <i className="fa fa-arrow-right" />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  <></>
                </div>
              ) : (
                <div className="loading-wrapper">
                  <img
                    src={"../../../assets/image/loading.svg"}
                    alt={"در حال بار گذاری"}
                  />
                </div>
              )}
            </div>
            <div className="col-xs-12 col-md-4 hidden-sm hidden-xs">
              <div className={styles.carouselTitle} ref={titleRef}>
                <div className={styles.squareSide} />
                <div className={styles.courseTitleText}>
                  <i className="fa fa-images" />
                  {title}
                </div>
              </div>
            </div>
            <div className="clearfix"></div>
          </div>
        </div>
        {open && (
          <div className={styles.modalWrapper}>
            <div className={styles.closeBtn} onClick={() => setIsOpen(false)}>
              <i className="fa fa-close" />
            </div>
            <ImageGallery items={images} />
          </div>
        )}
      </div>
    </>
  );
}
export const Card = memo(function ({ props }) {
  const { data, dataIndex } = props;
  const { cover } = data[dataIndex];
  const { handleGallery } = props;

  return (
    <div
      style={{
        width: "100%",
        height: window.screen.width > 768 ? 310 : 210,
        userSelect: "none",
      }}
      className="my-slide-component"
    >
      {data[dataIndex].type === "عکس" ? (
        <>
          <img
            style={{
              height: "100%",
              width: "100%",
              objectFit: "cover",
              borderRadius: 0,
            }}
            onClick={() => handleGallery(cover, dataIndex)}
            draggable={false}
            src={cover}
          />
        </>
      ) : (
        <video width="320" height="310" controls>
          <source src={cover} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
    </div>
  );
});
